import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import moment from "moment";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import Popup from "../../../../../../common/components/popup";
import { copyTextToClipBoard } from "../../../../../../common/services/common.service";
import { toast } from "react-toastify";
import { selectOpennetworkLogsListItems } from "../../../../../../redux/dbn-cloud/open-network-logs/selector";
import { opennetworkLogs } from "../../../../../../redux/dbn-cloud/open-network-logs/action";

const ManagementOpenNetworkLogs = (searchData: any) => {
  const searchdata: any = searchData?.searchData;
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeData, setActiveData] = useState<any>();
  const openNetworkLogsItems = useSelector(selectOpennetworkLogsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'transaction_id', headerName: 'Transaction Id', searchField: 'transaction_id', filter: true, filterType: 'text' },
      { field: 'message_id', headerName: 'Message Id', searchField: 'message_id', filter: true, filterType: 'text' },
      { field: 'bap_id', headerName: 'Buyer Id', searchField: 'bap_id', filter: true, filterType: 'text' },
      { field: 'action', headerName: 'Action', searchField: 'action', filter: true, filterType: 'text' },
      { field: 'domain', headerName: 'Domain', searchField: 'domain', filter: true, filterType: 'text' },
      { field: 'city', headerName: 'City', searchField: 'city', filter: true, filterType: 'text' },
      { field: 'context.timestamp', headerName: 'TimeStamp', searchField: 'timestamp', filter: true, filterType: 'text' },
    ]);
  }

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(opennetworkLogs.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/log-management/ondc-logs`,
      entity: 'opennetworkLogs',
      jsonData:
      {
        "FieldFiltersDto": {
          "StartDateIST": moment(searchdata?.StartDateIST).format('YYYY-MM-DDTHH:mm') || '',
          "EndDateIST": moment(searchdata?.EndDateIST).format('YYYY-MM-DDTHH:mm') || '',
          "transaction_id": searchdata?.TransactionId || '',
          "message_id": searchdata?.MessageId || '',
          "bap_id": "",
          "bpp_id": "",
          "city": searchdata?.City || '',
          "domain": searchdata?.DomainId || '',
          "action": searchdata?.Action || 'search'
        },
        "PaginationRequestDto": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
          "Searches": searchCriteria,
        }
      }
    }))
  }

  const handleReloadData = () => {
    fetchOpenNetworkLogsList();
  }

  const filterTypes = [
    {
      name: 'Text', value: "text"
    },
    {
      name: 'Number', value: "number"
    },
    {
      name: 'CheckBox', value: "checkbox"
    },
    {
      name: 'Date', value: "date"
    }
  ]

  const fetchOpenNetworkLogsList = () => {
    dispatch(opennetworkLogs.list({
      url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/log-management/ondc-logs`,
      entity: 'opennetworkLogs',
      jsonData:
      {
        "FieldFiltersDto": {
          "StartDateIST": moment(searchdata?.StartDateIST).format('YYYY-MM-DDTHH:mm') || '',
          "EndDateIST": moment(searchdata?.EndDateIST).format('YYYY-MM-DDTHH:mm') || '',
          "transaction_id": searchdata?.TransactionId || '',
          "message_id": searchdata?.MessageId || '',
          "bap_id": "",
          "bpp_id": "",
          "city": searchdata?.City || '',
          "domain": searchdata?.DomainId || '',
          "action": searchdata?.Action || 'search'
        },
        "PaginationRequestDto": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }
    }))
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const closeModal = () => {
    setActiveData(null)
    setIsModalOpen(false);
  };

  const copyToClipboard = async (data: any) => {
    await copyTextToClipBoard(JSON.stringify(data, null, 2))
    toast.info('Copied to clipboard')
  }

  const ShowJsonData = ({ data }: any) => {
    return (
      <>
        <Popup onClose={closeModal}>
          <>
            <div>
              <div className="flex flex-row justify-between items-center px-6">
                <div className="text-xl font-bold mb-4 text-center">{data?.action}</div>
                <div className="cursor-pointer" onClick={() => copyToClipboard(data)} title="Copy to clipboard">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
                    <path d="M9 15C9 12.1716 9 10.7574 9.87868 9.87868C10.7574 9 12.1716 9 15 9L16 9C18.8284 9 20.2426 9 21.1213 9.87868C22 10.7574 22 12.1716 22 15V16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H15C12.1716 22 10.7574 22 9.87868 21.1213C9 20.2426 9 18.8284 9 16L9 15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M16.9999 9C16.9975 6.04291 16.9528 4.51121 16.092 3.46243C15.9258 3.25989 15.7401 3.07418 15.5376 2.90796C14.4312 2 12.7875 2 9.5 2C6.21252 2 4.56878 2 3.46243 2.90796C3.25989 3.07417 3.07418 3.25989 2.90796 3.46243C2 4.56878 2 6.21252 2 9.5C2 12.7875 2 14.4312 2.90796 15.5376C3.07417 15.7401 3.25989 15.9258 3.46243 16.092C4.51121 16.9528 6.04291 16.9975 9 16.9999" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
              <pre>{JSON.stringify(data, null, 2)}</pre>
            </div>
          </>
        </Popup>
      </>
    )
  }

  const handleViewList = (data: any) => {
    setActiveData(data)
    setIsModalOpen(true);
  }

  useEffect(() => {
    createColumnDefs()
    fetchOpenNetworkLogsList()
  }, [pageData, pageSize])

  return (
    <>
      {isModalOpen && activeData ? <ShowJsonData data={activeData} /> : <></>}
      {openNetworkLogsItems?.isLoading ? <PageLoader /> :
        <Table
          columnData={columnDefs} rowData={openNetworkLogsItems?.result?.items}
          enableFilter={true} filterTypeLists={filterTypes} onSearch={handleSearch}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          setPageData={setPageData} setPageSize={setPageSize} paginationData={openNetworkLogsItems?.result?.pagination}
          additionButtons={additionButtons} onViewList={handleViewList}
          headingName="Open Network Logs"
        />
      }
    </>
  );
};

export default ManagementOpenNetworkLogs;


